<template>
	<div class="page profile-page">
		<van-nav-bar :title="$t('concubine.concubine') + ' · ' + $t('my.detail')" class="nav-bar profile-navbar">
			<template #left>
				<van-icon name="arrow-left" color="#fff" size="18" @click="back()" />
			</template>
		</van-nav-bar>

		<div class="profile-wrap" v-if="xuanfeidata && xuanfeidata.id">
			<!-- 大图轮播 -->
			<div class="banner-box" v-if="xuanfeidata.img_url && xuanfeidata.img_url.length > 0">
				<van-swipe class="banner-swipe" :autoplay="3500" indicator-color="rgba(255,255,255,.6)">
					<van-swipe-item v-for="(src,k) in xuanfeidata.img_url" :key="k">
						<van-image
							:src="src"
							width="100%"
							height="100%"
							fit="cover"
							class="banner-img"
						>
							<template v-slot:loading>
								<van-loading type="circular" />
							</template>
						</van-image>
					</van-swipe-item>
				</van-swipe>
			</div>

			<!-- 老师信息卡片 -->
			<div class="info-card">
				<div class="t-names">
					<!-- V 认证徽章 + 昵称（详情页用更大一档尺寸） -->
					<div class="name-with-badge name-with-badge-lg">
						<span class="v-badge v-badge-lg">
							<svg xmlns="http://www.w3.org/2000/svg" class="v-badge-icon v-badge-icon-lg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
								<path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"></path>
								<path d="m9 12 2 2 4-4"></path>
							</svg>
							<span class="v-badge-text v-badge-text-lg">{{ $t('choose.v_verified') }}</span>
						</span>
						<h2 class="t-nick">{{ xuanfeidata.xuanfei_name }}</h2>
					</div>
					<span class="t-real" v-if="xuanfeidata.teacher_name">（{{ xuanfeidata.teacher_name }}）</span>
				</div>

				<!-- 基础属性网格 -->
				<div class="base-grid">
					<div class="base-cell" v-if="xuanfeidata.age">
						<span class="base-k">{{ $t('choose.age') }}</span>
						<span class="base-v">{{ xuanfeidata.age }}{{ $t('choose.age_unit') }}</span>
					</div>
					<div class="base-cell" v-if="xuanfeidata.height">
						<span class="base-k">{{ $t('choose.height') }}</span>
						<span class="base-v">{{ xuanfeidata.height }}cm</span>
					</div>
					<div class="base-cell" v-if="xuanfeidata.weight">
						<span class="base-k">{{ $t('choose.weight') }}</span>
						<span class="base-v">{{ xuanfeidata.weight }}kg</span>
					</div>
					<div class="base-cell" v-if="xuanfeidata.education">
						<span class="base-k">{{ $t('choose.education') }}</span>
						<span class="base-v">{{ xuanfeidata.education }}</span>
					</div>
					<div class="base-cell" v-if="xuanfeidata.service_city">
						<span class="base-k">{{ $t('choose.service_city') }}</span>
						<span class="base-v">
							<van-icon name="location-o" size="12" color="#9a6c8f"/>
							{{ xuanfeidata.service_city }}
						</span>
					</div>
					<div class="base-cell" v-if="xuanfeidata.hometown">
						<span class="base-k">{{ $t('choose.hometown_label') }}</span>
						<span class="base-v">{{ xuanfeidata.hometown }}</span>
					</div>
				</div>

				<!-- 标签A -->
				<div class="tags-section" v-if="splitTags(xuanfeidata.tag_a).length > 0">
					<div class="tags-title">
						<span class="tags-dot dot-a"></span>{{ $t('choose.service_features') }}
					</div>
					<div class="tags-wrap">
						<span class="tag-badge" v-for="(t,i) in splitTags(xuanfeidata.tag_a)" :key="'a-'+i">{{ t }}</span>
					</div>
				</div>

				<!-- 标签B -->
				<div class="tags-section" v-if="splitTags(xuanfeidata.tag_b).length > 0">
					<div class="tags-title">
						<span class="tags-dot dot-b"></span>{{ $t('choose.good_at_courses') }}
					</div>
					<div class="tags-wrap">
						<span class="tag-badge" v-for="(t,i) in splitTags(xuanfeidata.tag_b)" :key="'b-'+i">{{ t }}</span>
					</div>
				</div>
			</div>

			<!-- 副标题 -->
			<p class="sub-title" v-if="xuanfeidata.vo_title">{{ xuanfeidata.vo_title }}</p>

			<!-- 服务流程 4 步 -->
			<div class="service-steps">
				<div class="step-item">
					<div class="step-icon-circle">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="step-svg">
							<rect width="14" height="20" x="5" y="2" rx="2" ry="2"></rect>
							<path d="M12 18h.01"></path>
						</svg>
					</div>
					<span class="step-text">{{ $t('choose.step_online_pick') }}</span>
				</div>
				<div class="step-item">
					<div class="step-icon-circle">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="step-svg">
							<circle cx="8" cy="21" r="1"></circle>
							<circle cx="19" cy="21" r="1"></circle>
							<path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"></path>
						</svg>
					</div>
					<span class="step-text">{{ $t('choose.step_place_order') }}</span>
				</div>
				<div class="step-item">
					<div class="step-icon-circle">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="step-svg">
							<path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8"></path>
							<path d="M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
						</svg>
					</div>
					<span class="step-text">{{ $t('choose.step_door_service') }}</span>
				</div>
				<div class="step-item">
					<div class="step-icon-circle">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="step-svg">
							<path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
							<circle cx="12" cy="8" r="6"></circle>
						</svg>
					</div>
					<span class="step-text">{{ $t('choose.step_review') }}</span>
				</div>
			</div>

			<!-- 富文本介绍 -->
			<div class="rich-card" v-if="hasRichHtml">
				<div class="rich-header">
					<span class="rich-bar"></span>
					<span class="rich-title">{{ $t('choose.notice') }}</span>
				</div>
				<div class="rich-content" v-html="safeHtml"></div>
			</div>

			<!-- 底部占位 -->
			<div class="bottom-gap"></div>
		</div>

		<!-- 空加载 -->
		<div class="empty-loading" v-else>
			<van-loading size="26px" color="#9a6c8f">{{ $t('choose.loading') }}</van-loading>
		</div>

		<!-- 底部预约按钮 fixed -->
		<div v-if="xuanfeidata && xuanfeidata.id" class="profile-bottom-bar">
			<button type="button" class="bottom-book-btn" @click="yuyue">{{ $t('foorter.subscribe') }}</button>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			xuanfeidata: null
		};
	},
	computed: {
		hasRichHtml() {
			const h = this.xuanfeidata && this.xuanfeidata.description_html;
			if (!h) return false;
			// 去掉空白/标签后还剩内容就显示
			const strip = String(h).replace(/<[^>]+>/g,'').replace(/&nbsp;/g,' ').trim();
			return strip.length > 0;
		},
		safeHtml() {
			return (this.xuanfeidata && this.xuanfeidata.description_html) || '';
		}
	},
	methods: {
		/**
		 * 统一解析 DB 里的标签字段，兼容三种格式：数组 / JSON字符串 / 逗号分隔文本
		 */
		splitTags(val) {
			if (val === null || val === undefined) return [];
			if (Array.isArray(val)) {
				return val.map(String).filter(t => (t || '').trim().length > 0);
			}
			let str = String(val).trim();
			if (!str) return [];
			try {
				let arr = JSON.parse(str);
				if (Array.isArray(arr)) {
					return arr.map(String).filter(t => (t || '').trim().length > 0);
				}
			} catch (e) {
				// 不是合法 JSON，忽略并继续按分隔符拆分（后台可能直接存 "A,B,C"）
			}
			let parts = str.split(/[,，;；\s]+/).filter(t => t.trim().length > 0);
			return Array.from(new Set(parts.map(String)));
		},
		back() {
			const adsid = this.$route.query.adsid;
			const name = this.$route.query.name;
			if (adsid) {
				this.$router.push({ path: 'list', query: { id: adsid, name: name || '' } });
			} else {
				this.$router.push({ path: 'Choose' });
			}
		},
		getxuanfeidata() {
			this.$http({
				method: 'get',
				url: 'xuanfeidata',
				data: { id: this.$route.query.id }
			}).then(res => {
				this.xuanfeidata = (res && res.data) ? res.data : null;
			}).catch(() => {
				this.xuanfeidata = null;
			});
		},
		yuyue() {
			this.$toast(this.$t("reservation.counselor"));
		}
	},
	created() {
		this.getxuanfeidata();
	}
};
</script>

<style scoped>
.profile-page {
	background: #f7f8fa;
	min-height: 100vh;
	padding-bottom: 60px;
}
.profile-navbar ::v-deep .van-nav-bar__content {
	background: linear-gradient(135deg, #7f5778 0%, #c98a9c 55%, #e5c2a0 100%);
}
.profile-navbar ::v-deep .van-nav-bar__title {
	color: #fff;
	font-weight: 600;
}
.profile-wrap {
	width: 100%;
}
.banner-box {
	width: 100%;
	background: #fff;
}
.banner-swipe {
	width: 100%;
	height: 375px;
}
.banner-swipe ::v-deep .van-swipe-item {
	background: #f2f3f5;
}
.banner-img {
	width: 100%;
	height: 100%;
}
.banner-img ::v-deep .van-image__img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}
.info-card {
	margin: -20px 14px 12px;
	background: #fff;
	border-radius: 18px;
	padding: 18px 16px 10px;
	box-shadow: 0 6px 20px rgba(30,30,60,0.06);
	position: relative;
	z-index: 2;
}
.t-names {
	display: flex;
	align-items: baseline;
	flex-wrap: wrap;
	margin-bottom: 14px;
}
.t-nick {
	font-size: 50px;
	font-weight: 700;
	color: #1d1d1f;
	margin: 0;
	letter-spacing: 0.5px;
}
.t-real {
	font-size: 26px;
	color: #999;
	margin-left: 8px;
}
.base-grid {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 8px 16px;
	padding: 12px 12px;
	background: linear-gradient(135deg, rgba(127,87,120,0.06) 0%, rgba(229,194,160,0.07) 100%);
	border-radius: 12px;
	margin-bottom: 6px;
}
.base-cell {
	display: flex;
	align-items: center;
	font-size: 26px;
	line-height: 1.6;
}
.base-k {
	color: #888;
	min-width: 58px;
	flex-shrink: 0;
}
.base-v {
	color: #222;
	font-weight: 500;
	min-width: 0;
	overflow: hidden;
	word-break: break-all;
}
.tags-section {
	margin-top: 14px;
}
.tags-title {
	display: flex;
	align-items: center;
	font-size: 26px;
	color: #666;
	margin-bottom: 8px;
}
.tags-dot {
	display: inline-block;
	width: 7px;
	height: 7px;
	border-radius: 50%;
	margin-right: 6px;
}
.dot-a { background: linear-gradient(135deg,#ff6a88,#ff99ac); }
.dot-b { background: linear-gradient(135deg,#60a5fa,#7f5778); }
.tags-wrap {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
}
.tag-badge {
	display: inline-block;
	padding: 4px 10px;
	font-size: 24px;
	line-height: 1.4;
	border-radius: 6px;
	background: #f7ddc7;
	color: #3d2f1a;
	white-space: nowrap;
}

.sub-title {
	padding: 6px 20px 0;
	font-size: 24px;
	color: #aaa;
}

/* 服务流程 4 步（等价 Tailwind grid-cols-4 / gap-2 + 圆形边框图标 + text-10px c4a574 文字） */
.service-steps {
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 8px;
	margin: 14px 14px 0;
	padding: 18px 10px;
	background: #fff;
	border-radius: 16px;
	box-shadow: 0 2px 10px rgba(20,20,40,0.04);
}
.step-item {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
}
.step-icon-circle {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 96px;
	height: 96px;
	border-radius: 50%;
	border: 1px solid rgba(196,165,116,0.7);
	color: #c4a574;
}
.step-svg {
	width: 40px;
	height: 40px;
	display: block;
}
.step-text {
	margin-top: 8px;
	text-align: center;
	font-size: 20px;
	line-height: 1.25;
	color: #c4a574;
}

.rich-card {
	margin: 12px 14px 12px;
	background: #fff;
	border-radius: 16px;
	padding: 16px;
	box-shadow: 0 2px 10px rgba(20,20,40,0.04);
}
.rich-header {
	display: flex;
	align-items: center;
	margin-bottom: 12px;
}
.rich-bar {
	display: inline-block;
	width: 3px;
	height: 14px;
	border-radius: 2px;
	background: linear-gradient(180deg,#9a6c8f,#e5c2a0);
	margin-right: 8px;
}
.rich-title {
	font-size: 28px;
	font-weight: 600;
	color: #1d1d1f;
}
/* 富文本样式：穿透到 v-html 内（全部展平，不用 SCSS 嵌套） */
.rich-content {
	font-size: 28px;
	line-height: 1.7;
	color: #333;
	word-break: break-word;
}
.rich-content ::v-deep img {
	max-width: 100%;
	height: auto;
	border-radius: 8px;
	display: block;
	margin: 8px auto;
}
.rich-content ::v-deep table {
	width: 100% !important;
	border-collapse: collapse;
	margin: 8px 0;
}
.rich-content ::v-deep td,
.rich-content ::v-deep th {
	border: 1px solid #eee;
	padding: 6px 8px;
	vertical-align: top;
}
.rich-content ::v-deep p { margin: 6px 0; }
.rich-content ::v-deep h1,
.rich-content ::v-deep h2,
.rich-content ::v-deep h3,
.rich-content ::v-deep h4,
.rich-content ::v-deep h5,
.rich-content ::v-deep h6 {
	font-weight: 600;
	margin: 10px 0 6px;
	color: #111;
}
.rich-content ::v-deep h1 { font-size: 36px; }
.rich-content ::v-deep h2 { font-size: 32px; }
.rich-content ::v-deep h3,
.rich-content ::v-deep h4 { font-size: 30px; }
.rich-content ::v-deep ul,
.rich-content ::v-deep ol {
	padding-left: 22px;
	margin: 6px 0;
}
.rich-content ::v-deep li { margin: 2px 0; }
.rich-content ::v-deep a {
	color: #6d3e79;
	text-decoration: underline;
}
.rich-content ::v-deep blockquote {
	border-left: 3px solid #d6bfb0;
	background: #faf7f4;
	margin: 8px 0;
	padding: 8px 12px;
	color: #555;
	border-radius: 0 6px 6px 0;
}
.rich-content ::v-deep strong,
.rich-content ::v-deep b {
	font-weight: 600;
	color: #111;
}
.rich-content ::v-deep iframe,
.rich-content ::v-deep video,
.rich-content ::v-deep embed {
	max-width: 100%;
	border-radius: 8px;
}
.rich-content ::v-deep hr {
	border: none;
	border-top: 1px dashed #e8e8ed;
	margin: 14px 0;
}
.empty-loading {
	padding: 120px 0 0;
	text-align: center;
	color: #999;
}
.bottom-gap {
	height: 140px; /* 给 fixed 底部条留安全区，防止最后一屏被挡 */
}

/* 底部 fixed 预约条（等价 Tailwind fixed bottom-0 left-0 right-0 z-50 / max-w-md / bg-black/80 backdrop-blur-sm / px-4 py-3 + safe-area） */
.profile-bottom-bar {
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 50;
	margin: 0 auto;
	max-width: 750px;
	
	padding: 12px 16px;
	padding-bottom: calc(12px + env(safe-area-inset-bottom));
	-webkit-backdrop-filter: blur(4px);
	backdrop-filter: blur(4px);
}
.bottom-book-btn {
	width: 100%;
	border: none;
	outline: none;
	border-radius: 12px; /* rounded-xl */
	background: #c9a86c;
	padding: 28px 0; /* py-3.5 移动端 2x 换算 */
	font-size: 32px; /* text-base 移动端 2x 换算 */
	font-weight: 500;
	color: #000;
	line-height: 1.4;
	cursor: pointer;
}
.bottom-book-btn:active {
	transform: scale(0.98);
	opacity: 0.92;
}
.bottom-book-btn:disabled {
	opacity: 0.6;
	pointer-events: none;
}

/* V 认证徽章 + 昵称组合（基础卡片尺寸 + 详情页更大一档） */
.name-with-badge {
	display: inline-flex;
	align-items: center;
	gap: 12px;
	max-width: 100%;
	flex-wrap: nowrap;
}
.name-with-badge-lg {
	gap: 18px;
}
.v-badge {
	display: inline-flex;
	flex-shrink: 0;
	align-items: center;
	gap: 6px;
	padding: 6px 12px;
	border-radius: 6px;
	background-image: linear-gradient(to right, #d4b896, #b8956a);
	color: #3d2f1a;
}
.v-badge-lg {
	padding: 8px 20px;
	border-radius: 8px;
	gap: 8px;
}
.v-badge-icon {
	width: 28px;
	height: 28px;
	display: inline-block;
	flex-shrink: 0;
}
.v-badge-icon-lg {
	width: 44px;
	height: 44px;
}
.v-badge-text {
	font-size: 24px;
	font-weight: 600;
	color: #3d2f1a;
	line-height: 1;
	white-space: nowrap;
}
.v-badge-text-lg {
	font-size: 36px;
}

@media (max-width: 360px) {
	.banner-swipe { height: 320px; }
}
</style>
